import { makeStyles } from '@material-ui/core/styles';


export const panelAlcoholStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },

  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 190,
  },
  search: {
    // border: "2px solid #2c8aaf",
    borderRadius: "5px",
    height: "10px",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 1px 1px rgb(0 0 0 / 8%)"

  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },

  buttonProgress: {
    color: '#0088FE',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  titleList:{
    textAlign:'center',
    fontSize:'18px'
  }
}));